import React from 'react';
import {Filter, FilterProps} from 'react-admin';

const VideoPlaylistFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <></>
    </Filter>
);

export default VideoPlaylistFilter;
